import { Component } from '@angular/core';
import { QuestionService } from '../../services/question.service';
import { Question, QuestionResponse } from '../../models/question.model';
import { NgClass, NgFor, NgIf } from '@angular/common';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-questions-view',
  standalone: true,
  imports: [NgFor, NgClass, NgIf, RouterLink],
  templateUrl: './questions-view.component.html',
  styleUrl: './questions-view.component.scss'
})
export class QuestionsViewComponent {
  isLoading: boolean = true;
  questions: Question[] = [];

  constructor (private questionService:QuestionService){}

   ngOnInit() {
      this.questionService.getQuestions(1, '').subscribe((response: QuestionResponse) => {
        this.questions = response.questions.data; 
        this.isLoading = false;
      }, (error) => {
        console.error('Erro ao carregar as perguntas', error);
        this.isLoading = false;
      });
    }
}
